export default __webpack_public_path__ + "static/media/Group 3054.8df6eebe.png";